import { WeekDay } from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';
import { Vue, Options } from 'vue-class-component';
import { SceneUtils } from '@/core/utils/scene.utils';

@Options({
  name: 'TimeSelectorComponent',
  props: {
    modelValue: {
      type: Object as PropType<WeekDay[]>,
    },
  },
  emits: ['update:modelValue'],
})
export default class TimeSelectorComponent extends Vue {
  insideDaysValue: WeekDay[] = [];
  modelValue!: WeekDay[];
  SceneUtils = SceneUtils;
  
  mounted() {
    if (this.modelValue) this.insideDaysValue = this.modelValue;
  }

  get typeOptions() {
    return Object.keys(WeekDay)
      .filter((value) => !isNaN(Number(value)))
      .map((value) => ({ key: Number(value), value: WeekDay[value as any] }));
  }

  toggleDay(day: any) {
    if (this.insideDaysValue.includes(day)) {
      this.insideDaysValue = this.insideDaysValue.filter((o) => o !== day);
    } else {
      this.insideDaysValue = [...this.insideDaysValue, day].sort();
    }

    this.$emit('update:modelValue', this.insideDaysValue);
  }
}
